import $ from "jquery";
import Swiper, {Pagination} from "swiper";

export default function onResizeWindow() {


    window.addEventListener("resize", function (e) {

        if(window.innerWidth <= 992) {
            $('.wp-block-cover .avu-textbox-container').each(function() {
                let textboxContainer = $(this);
                if (textboxContainer.parents('.wp-block-cover').length > 0) {
                    let heightTextbox = textboxContainer.find('.avu-textbox').outerHeight() + 120;
                    textboxContainer.parents('.wp-block-cover').css('min-height', heightTextbox + 'px');
                }
            });
            $(".avu-nav-desktop").attr("aria-hidden","true");
            $(".avu-nav-mobile").attr("aria-hidden","false");
            $(".avu-services-template-nav-desktop").attr("aria-hidden","true").addClass('d-none');
            $(".avu-services-template-nav-mobile").attr("aria-hidden","false").removeClass('d-none');
            //Move social link
            let $lastLi = $('#menu-fussnavigation > li:last-child .submenu');
            $('#menu-fussnavigation > li:last-child').css('display', 'none');
            let $menuMobileItem = $('.menu-mobile-item');
            $menuMobileItem.append($lastLi);
            let $topLink = $('.avu-footer-navigation .avu-footer-go-top-container');
            $('.avu-footer-siegel-container').append($topLink);
            $('#collapseMagazinCategory').addClass("collapse");
            $('#collapseMagazinCategoryButton').attr("aria-hidden","false");
            $('.avu-swiper-contact-container').addClass("avu-swiper-contact");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container').addClass("swiper-wrapper");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container .avu-contact-categories-list-item').addClass("swiper-slide");
        }
        if(window.innerWidth > 992) {
            $('.wp-block-cover .avu-textbox-container:not(.image-outside-top):not(.image-outside-bottom)').each(function() {
                let textboxContainer = $(this);
                if (textboxContainer.parents('.wp-block-cover').length > 0) {
                    let heightTextbox = textboxContainer.find('.avu-textbox').outerHeight() + 240;
                    textboxContainer.parents('.wp-block-cover').css('min-height', heightTextbox + 'px');
                }
            });
            $(".avu-nav-desktop").attr("aria-hidden","false");
            $(".avu-nav-mobile").attr("aria-hidden","true");
            $(".avu-services-template-nav-desktop").attr("aria-hidden","false").removeClass('d-none');
            $(".avu-services-template-nav-mobile").attr("aria-hidden","true").addClass('d-none');
            //Move social link
            let $lastLi = $('.menu-mobile-item .submenu');
            $('#menu-fussnavigation li:last-child').css('display', 'block');
            let $menuMobileItem = $('#menu-fussnavigation > li:last-child');
            $menuMobileItem.append($lastLi);
            let $topLink = $('.avu-footer-siegel-container .avu-footer-go-top-container');
            $('.avu-footer-navigation').append($topLink);
            $('#collapseMagazinCategory').removeClass("collapse");
            $('#collapseMagazinCategoryButton').attr("aria-hidden","true");
            $('.avu-swiper-contact-container').removeClass("avu-swiper-contact");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container').removeClass("swiper-wrapper");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container .avu-contact-categories-list-item').removeClass("swiper-slide");

        }
    });

}